(function () {
  var sectionId = window.__zdcSectionId; 
  var messages = window.__zdcMessages || {};
  var MAX_WAIT_MS = 8000; 
  var POLL_INTERVAL_MS = 200;

  function init() {
    var form = document.querySelector('#zapiet-custom-check-' + sectionId + ' .zdc-form');
    var input = document.getElementById('zdc-zipcode-' + sectionId);
    var button = document.getElementById('zdc-button-' + sectionId);
    var result = document.getElementById('zdc-result-' + sectionId);

    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      checkDelivery();
    });

    function isZapietReady() {
      return (
        typeof window.Zapiet !== 'undefined' &&
        typeof window.ZapietDeliveryValidator !== 'undefined' &&
        typeof window.ZapietCachedSettings !== 'undefined' &&
        typeof window.ZapietCachedSettings.cached_config !== 'undefined' &&
        typeof window.ZapietCachedSettings.cached_config.delivery_validator !== 'undefined'
      );
    }

    function waitForZapiet(onReady, onTimeout) {
      if (isZapietReady()) {
        onReady();
        return;
      }
      var waited = 0;
      var timer = setInterval(function () {
        waited += POLL_INTERVAL_MS;
        if (isZapietReady()) {
          clearInterval(timer);
          onReady();
        } else if (waited >= MAX_WAIT_MS) {
          clearInterval(timer);
          onTimeout();
        }
      }, POLL_INTERVAL_MS);
    }

    function setState(state, text) {
      result.className = 'zdc-result' + (state ? ' ' + state : '');
      result.textContent = text;
    }

    function checkDelivery() {
      var value = input.value.trim();
      if (!value) return;

      button.disabled = true;
      setState('', messages.loading);

      waitForZapiet(
        function onReady() {
          window.ZapietDeliveryValidator.checkEligibility(
            value,
            function (response) {
            
              window.ZapietDeliveryValidator.eligibleForDelivery(response);
              button.disabled = false;
              setState('success', messages.success);
            },
            function () {
             
              window.ZapietDeliveryValidator.notEligibleForDelivery();
              button.disabled = false;
              setState('error', messages.error);
            },
            function () {
              window.ZapietDeliveryValidator.error();
              button.disabled = false;
              setState('error', messages.apiError);
            }
          );
        },
        function onTimeout() {
          button.disabled = false;
          setState('error', messages.apiError);
          console.warn(
            'Zapiet Delivery Validator is not loaded'
          );
        }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();